import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { MatSelectChange } from '@angular/material/select';
import { CommandService } from '../../shared/services/command.service';
import { IControlInputReferenceType } from '../../shared/models/device';
import { DeviceInputBaseComponent } from '../device-input-base.component';
import {
    CommandOptimizationRenderingService,
} from '@caslink/device-client/ng-app/shared/services/command-optimization-rendering.service';

@Component({
    selector: 'dl-select-list',
    templateUrl: './select-list-input.component.html',
    styleUrls: ['./select-list-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectListInputComponent extends DeviceInputBaseComponent {
    static $name: string = 'selectList';

    formControl: FormControl;

    private ITEMS_LIMIT = 3;

    constructor(
        private commandService: CommandService,
        protected commandOptimizationRenderingService: CommandOptimizationRenderingService,
        protected cdr: ChangeDetectorRef,
    ) {
        super(commandService, commandOptimizationRenderingService, cdr);
    }

    ngOnInit() {
        super.ngOnInit();

        let validators = [
            Validators.required
        ];

        this.formControl = this.deviceInputForm?.get(this.deviceInput.$fieldName) as FormControl || new FormControl(this.deviceInput.value, validators);
        this.deviceInputForm.addControl(this.deviceInput.$fieldName, this.formControl);
    }

    invokeCommand(matSelectChange: MatSelectChange | MatButtonToggleChange) {
        this.deviceInput.value = matSelectChange.value;
        this.invokeChangeCommand(this.deviceInput);
    }

    trackByValue(index: number, item: IControlInputReferenceType) {
        return item.value;
    }

    hasManyItems() {
        return this.deviceInput &&
            this.deviceInput.$valueList &&
            this.deviceInput.$valueList.length > this.ITEMS_LIMIT;
    }
}
